import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ArtaFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Este cursul potrivit dacă sunt foarte ocupată?',
    a: 'Da, mai ales dacă ești foarte ocupată. Tehnicile sunt simple și se pot aplica în câteva minute, chiar și într-un program aglomerat. Nu ai nevoie de ore libere. Ai nevoie de 5-10 minute și de voința de a le folosi.'
  }, {
    q: 'În cât timp simt rezultate?',
    a: 'Unele tehnici au efect imediat. Calmarea minții prin respirație funcționează din prima aplicare. Rezultatele mai profunde, cum ar fi reducerea stresului cronic și crearea de obiceiuri noi, cresc în timp pe măsură ce practici zilnic.'
  }, {
    q: 'Este un curs teoretic sau practic?',
    a: 'Este foarte practic. Primești informații clare despre ce e stresul și cum funcționează, dar cel mai mult primești exerciții concrete pe care le aplici imediat. Fiecare lecție vine cu o tehnică pe care o poți folosi chiar în ziua în care o înveți.'
  }, {
    q: 'Pot reduce complet stresul?',
    a: 'Scopul nu este eliminarea totală a stresului, pentru că un anumit nivel de stres e natural și chiar util. Scopul este să înveți să îl gestionezi, să nu te mai copleșească și să rămâi în echilibru chiar și când viața e agitată.'
  }, {
    q: 'Mă ajută dacă sunt foarte anxioasă?',
    a: 'Da. Tehnicile de respirație și calmare a minții din curs sunt foarte utile pentru anxietate. Nu înlocuiesc un tratament medical dacă ai nevoie de unul, dar te ajută să îți reglezi starea emoțională și să te simți mai calmă zilnic.'
  }, {
    q: 'Pot cumpăra doar acest curs fără tot pachetul Academiei?',
    a: 'Da. Cursul se poate achiziționa separat la 500 lei cu acces pe viață. Dacă vrei toate cele 6 cursuri plus întâlniri de grup, Programul Standard complet costă 1.985 lei integral și economisești față de cumpărarea separată.'
  }, {
    q: 'Am nevoie de echipament special sau de un spațiu dedicat?',
    a: 'Nu. Ai nevoie doar de câteva minute liniștite. Poți practica tehnicile acasă, la birou, chiar și în mașină (nu cele care cer ochi închiși). Sunt gândite pentru viața reală, nu pentru condiții perfecte.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-126">
      <div className="max-w-4xl mx-auto px-6" data-id="element-127">
        <SectionHeading title="Întrebări Frecvente" data-id="element-128" />

        <div className="space-y-4 mb-16" data-id="element-129">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-130">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-131">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-132">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-133" />
              </button>
              <AnimatePresence data-id="element-134">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-135">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-136">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-137">
          <CTAButton data-id="element-138" />
        </motion.div>
      </div>
    </section>;
}